import { render, staticRenderFns } from "./SettingsGrids.vue?vue&type=template&id=ea3d9664&scoped=true&"
import script from "./SettingsGrids.vue?vue&type=script&lang=js&"
export * from "./SettingsGrids.vue?vue&type=script&lang=js&"
import style0 from "./SettingsGrids.vue?vue&type=style&index=0&id=ea3d9664&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea3d9664",
  null
  
)

export default component.exports